<template>
  <div class="mobile">
    <div class="ask-container">
      <div class="goback">
        <div class="goback_box">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i> <span>返回</span>
          </div>
          <!-- <div class="goback_search">
            <el-select
              v-model="valuePeople"
              placeholder="请选择"
              @change="changePeople"
            >
              <el-option label="上级" value="上级"> </el-option>
              <el-option label="同事" value="同事"> </el-option>
              <el-option label="本人" value="本人"> </el-option>
              <el-option label="下属" value="下属"> </el-option>
            </el-select>
          </div> -->
        </div>
      </div>
      <h1 class="title text-center pt-6">{{ base.title }}</h1>
      <div v-if="valuePeople == '本人'">
        <p class="desc mt-1" v-if="currentPage == 0">
          抱负是指员工对于声誉与认可、晋升与影响力以及经济回报的渴望程度。以下问题有助于识别具有高抱负的员工。
        </p>
        <p class="desc mt-1" v-if="currentPage == 1">
          敬业度是指员工对组织的珍视、喜爱程度，以及他们相信留在组织符合自身最大利益的程度。以下问题有助于识别那些具有高敬业度的员工。
        </p>
      </div>
      <div v-else>
        <p class="desc mt-1" v-if="currentPage == 0">
          能力是指员工在日常工作中所展现的特质与技能的综合运用能力，以下问题有助于识别具有高能力的员工。
        </p>
        <p class="desc mt-1" v-if="currentPage == 1">
          抱负是指员工对于声誉与认可、晋升与影响力以及经济回报的渴望程度。以下问题有助于识别具有高抱负的员工。
        </p>
        <p class="desc mt-1" v-if="currentPage == 2">
          敬业度是指员工对组织的珍视、喜爱程度，以及他们相信留在组织符合自身最大利益的程度。以下问题有助于识别那些具有高敬业度的员工。
        </p>
      </div>
      <div
        class="content mt-6"
        v-if="
          paginatedAskList[0]?.personnelList &&
          paginatedAskList[0].personnelList.length > 0
        "
      >
        <div v-if="valuePeople == '本人'">
          <h1 class="title mb-4" v-if="currentPage == 0">抱负评估问题清单</h1>
          <h1 class="title mb-4" v-if="currentPage == 1">敬业度评估问题清单</h1>
        </div>
        <div v-else>
          <h1 class="title mb-4" v-if="currentPage == 0">能力评估问题清单</h1>
          <h1 class="title mb-4" v-if="currentPage == 1">抱负评估问题清单</h1>
          <h1 class="title mb-4" v-if="currentPage == 2">敬业度评估问题清单</h1>
        </div>
        <div class="ask" v-for="(item, index) in paginatedAskList" :key="index">
          <h5 class="ask-title">
            {{ currentIndex + index + 1 + "、" + item.question }}
          </h5>
          <div class="item flex-around">
            <span class="username"></span>
            <span
              class="radio-box"
              v-for="(option, opt) in item.option.split(',')"
              :key="opt"
              >{{ option }}</span
            >
          </div>
          <div
            class="item flex-around"
            v-for="(child, idx) in item.personnelList"
            :key="idx"
          >
            <span
              class="username"
              :class="{ 'text-alert': showTips && child.marking === '' }"
            >
              {{ child.evaluatePersonnelName }}
            </span>
            <span
              class="radio-box"
              @click="changeRadio(child, option)"
              v-for="(option, opt) in pointList"
              :key="opt"
            >
              <van-radio
                :name="option"
                v-model="child.point"
                :disabled="child.evaluate"
              ></van-radio>
            </span>
          </div>
        </div>
      </div>
      <div
        class="content mt-6"
        v-else
        style="font-size: 16px; text-align: center"
      >
        暂无可评选人员
      </div>
      <div class="btn-box flex-between">
        <button
          class="btn btn-inline"
          :class="{ 'btn-disabled': currentPage === 0 }"
          @click="prevPage"
        >
          上一页
        </button>
        <button
          class="btn"
          :class="{ 'btn-disabled': !isComplete }"
          @click="nextPage"
          v-if="!isLastPage"
        >
          下一页
        </button>
        <button
          class="btn"
          :class="{ 'btn-disabled': submitDisabled }"
          @click="nextPage"
          v-if="isLastPage"
        >
          提交
        </button>
      </div>
    </div>
  </div>
</template>
<script>
// import testdata from "@/assets/testdata.json";
// import testdata2 from "@/assets/testdata2.json";
import api from "@/apis/evaluation";

export default {
  components: {},
  data() {
    return {
      showTips: false,
      step: 0, //控制上一项是否可以点击
      base: {
        title: "雷士照明高潜人才诊断问题",
      },
      askList: [],
      valuePeople: "",
      optionPeople: [],
      pointList: [5, 4, 3, 2, 1],
      currentPage: 0,
      pageSizes: [7, 5, 5],
      userinfo: {},
      submitDisabled: false,
    };
  },
  created() {
    const loginEvaluation = JSON.parse(sessionStorage.getItem("loginEvaluation"));
    if (loginEvaluation) {
       this.userinfo = loginEvaluation;
    } else {
      this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    }
    // this.getAskForm();
    const { type } = this.$route.query;
    if (type) {
      this.valuePeople = type;
      if (type == "上级") {
        // this.pageSizes = [7];
        this.pageSizes = [7, 5, 5];
      } else if (type == "同事") {
        this.pageSizes = [7, 5, 5];
      } else if (type == "本人") {
        this.pageSizes = [5, 5];
      } else if (type == "下属") {
        this.pageSizes = [7];
        // this.pageSizes = [7, 5, 5];
      }
    }
    this.getList();
  },

  computed: {
    // 分页
    paginatedAskList() {
      let start = this.pageSizes
        .slice(0, this.currentPage)
        .reduce((a, b) => a + b, 0);
      let size = this.pageSizes[this.currentPage] || 0;
      return this.askList.slice(start, start + size);
    },
    // 是否完成
    isComplete() {
      return this.paginatedAskList.every(
        (item) =>
          item.personnelList &&
          item.personnelList.every((ask) => ask.point != "")
      );
    },
    // 是否是最后一页
    isLastPage() {
      return this.currentPage === this.pageSizes.length - 1;
    },
    // 当前索引
    currentIndex() {
      return this.pageSizes
        .slice(0, this.currentPage)
        .reduce((a, b) => a + b, 0);
    },
  },
  methods: {
    // changeRadio(child, option) {
    //   // 直接修改 `askList` 中的数据，而不是 `paginatedAskList`
    //   let index = this.askList.findIndex((item) => item.list.includes(child));
    //   if (index !== -1) {
    //     let childIndex = this.askList[index].list.indexOf(child);
    //     if (childIndex !== -1) {
    //       this.$set(this.askList[index].list[childIndex], "marking", option);
    //     }
    //   }
    //   this.askList = [...this.askList];
    //   this.$forceUpdate();
    //   console.log(this.askList, "askList");
    // },
    // 选中
    changeRadio(child, option) {
      if (child.evaluate) return;
      // child.marking = option;
      this.$set(child, "point", Number(option));
      this.askList = [...this.askList];
      this.$forceUpdate();
      console.log(this.askList, "askList");
    },
    // 获取列表
    getList() {
      const { activityId } = this.$route.query;
      api
        .evaluateQuestionsQueryList({
          evaluatorCode: this.userinfo.username,
          type: this.valuePeople,
          activityId: activityId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.askList = res.data;
            let array = [];
            res.data.length > 0 &&
              res.data[0]?.personnelList.length > 0 &&
              res.data[0]?.personnelList.forEach((item) => {
                array.push(item.evaluate);
              });
            this.submitDisabled = array.every((item) => item === true);
          }
        });
    },
    // 选择考评对象
    changePeople(val) {
      if (val == "上级") {
        this.pageSizes = [7, 5, 5];
        // this.pageSizes = [7];
      } else if (val == "同事") {
        this.pageSizes = [7, 5, 5];
      } else if (val == "本人") {
        this.pageSizes = [5, 5];
      } else if (val == "下属") {
        this.pageSizes = [7];
        // this.pageSizes = [7, 5, 5];
      }
      this.getList();
    },
    // 返回
    goback() {
      this.$router.go(-1);
      // this.$router.push("/evaluation");
    },
    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.showTips = false;
      }
    },
    // 下一页
    nextPage() {
      if (!this.isComplete) {
        this.showTips = true;
        this.$message.warning("请全部评选完毕");
        return;
      }
      if (this.isLastPage) {
        this.submit();
      } else {
        this.currentPage++;
      }
    },
    // 提交
    submit() {
      if (this.submitDisabled) return this.$message.warning("您已经提交过");
      const obj = JSON.parse(sessionStorage.getItem("evaluationObject"));
      const params = {
        evaluatorCode: obj.evaluatorCode, // 考评人工号
        deptName: obj.deptName, // 部门
        answerList: this.askList, // 答题列表
        activityId: obj.activityId, // 活动标题
        relation: obj.relation,
      };
      console.log("提交问卷", params);
      api.evaluateManageAdd(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success", // success error warning
            message: "提交成功",
            duration: 2000,
          });
          // this.disabledNext = false;
          // this.disabled = true;
          this.submitDisabled = true;
          sessionStorage.removeItem("evaluationObject");
          this.$router.go(-1);
          // sessionStorage.removeItem("params");
        }
      });
      // this.$message.success("提交成功");
    },
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .ask-container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .ask-container {
    width: 306px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
// ========public样式=============
.mt-1 {
  margin-top: 10px;
}

.mb-1 {
  margin-bottom: 10px;
}

.mb-4 {
  margin-bottom: 30px;
}

.mt-6 {
  margin-top: 30px;
}

.pt-6 {
  padding-top: 30px;
  margin-bottom: 30px;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-around {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 30px !important;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-center {
  text-align: center;
}

.text-alert {
  color: #e24635 !important;
}

// ========public样式end=============
.ask-container {
  min-height: 100vh;
  // background: linear-gradient(180deg, #b9f9f3 0%, #ffffff 29%, #ffffff 100%);
  background: url("~@/assets/evaluation/bg2.png") no-repeat;
  background-size: 100% 100%;
  padding: 30px;

  .title {
    font-weight: bold;
    font-size: 32px;
    color: #121826;
  }

  .desc {
    font-size: 26px;
    color: #666666;
  }

  .content {
    padding: 40px 20px;
    box-shadow: 0px 0px 9px 0px rgba(60, 60, 60, 0.18);
    border-radius: 10px;

    .ask {
      &:not(:last-child) {
        margin-bottom: 40px;
      }
    }

    .ask-title {
      font-weight: 400;
      font-size: 28px;
      color: #121826;
      margin-top: 30px;
      margin-bottom: 40px;
    }

    .tips {
      font-size: 24px;
      color: #e24635;
    }

    .item {
      &:not(:last-child) {
        margin-bottom: 20px;
      }

      .username {
        min-width: 90px;
      }

      & > span {
        font-size: 28px;
        color: #666666;
      }

      .radio-box {
        flex: 1 0;
        display: flex;
        justify-content: center;
        font-size: 22px;
      }

      .radio {
        display: inline-block;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 1px solid #dbdada;
        position: relative;

        .tap {
          position: absolute;
          top: -60px;
          left: 50%;
          transform: translate(-50%);
          width: 150px;
          text-align: center;
          font-style: normal;
        }

        &.checked {
          border: 1px solid #1fbe8a;

          &::after {
            content: "";
            position: absolute;
            width: 34px;
            height: 34px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            background: #1fbe8a;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .btn-box {
    margin-top: 100px;
    padding-bottom: 60px;

    .btn {
      width: 232px;
      height: 84px;
      background: #1fbe8a;
      border-radius: 16px;
      font-weight: 800;
      font-size: 32px;
      color: #ffffff;

      &-inline {
        background: transparent;
        border: 1px solid #1fbe8a;
        color: #1fbe8a;
      }

      &-disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

.goback {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .goback_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 30px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;
    width: 260px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
      .el-input__icon {
        line-height: 38px !important;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
</style>
